import React, { FC, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';

import { Image } from 'antd';
import ScrollArrow from 'components/ScrollArrow';
import classnames from 'classnames';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

import { useSize } from 'ahooks';
import { getRootFontSize, setScrollbarVar } from 'utils/rem';
import { useHistory } from 'react-router-dom';

import gamesBg from 'assets/imgs/game-icons.png';
import phonePeople from 'assets/imgs/game-people.png';
import phoneEarth from 'assets/imgs/game-earth.png';
import phoneShip from 'assets/imgs/game-ship.png';
import phoneBird from 'assets/imgs/game-bird.png';
import phoneButterfly from 'assets/imgs/game-butterfly.png';
import phoneFlower from 'assets/imgs/game-flower.png';

import logoBlockBlast from 'assets/imgs/logo-blockBlast.png';
import childs from 'assets/imgs/childs.png';
import iconApple from 'assets/imgs/icon-apple.png';
import iconGoogle from 'assets/imgs/icon-google.png';
import iconLinkedin from 'assets/imgs/company_linkedin.png';
import iconYoutube from 'assets/imgs/company_youtobe.png';
import iconHotspot from 'assets/imgs/icon-hotspot.png';
import tiktok from 'assets/imgs/games_tiktok.png';
import instagram from 'assets/imgs/games_instagram.png';
import twitter from 'assets/imgs/games_twitter.png';
import facebook from 'assets/imgs/games_facebook.png';
import gamesYoutube from 'assets/imgs/games_youtobe.png';
import discord from 'assets/imgs/games_discord.png';

import styles from './index.module.less';
import BgImg, { BgNameType } from 'components/BgImg';
import Torch from 'components/Torch';
import { reqBlogListByPage, reqMediaListByPage } from 'api';
import { formatDate } from 'utils';
import TorchRing from 'components/TorchRing';
import { useGSAP } from '@gsap/react';
import MySwiper from 'components/MySwiper';

const phoneList = [phonePeople, phoneEarth, phoneShip, phoneBird, phoneButterfly, phoneFlower];
const contactData = [
  {
    title: (
      <>
        For Support, Questions, And Advice Regarding Our Games,
        <br />
        Please Email
      </>
    ),
    address: 'support@hungrystudio.com',
  },
  {
    title: (
      <>
        For Inquiries Related To Press, Events, And Public Affairs,
        <br />
        Please Email
      </>
    ),
    address: 'communication@hungrystudio.com',
  },
  {
    title: (
      <>
        For Influencer Promotional And Paid Collaboration Inquiries,
        <br />
        Please Email
      </>
    ),
    address: 'influencercollab@hungrystudio.com',
  },

  {
    title: (
      <>
        For Business Alignment And Collaboration,
        <br />
        Please Email
      </>
    ),
    address: 'BD@hungrystudio.com',
  },
];

const Home: FC = () => {
  const history = useHistory();
  const [spaceBetween, setSpaceBetween] = useState<number>(73);
  const [blogList, setBlogList] = useState<any[]>([]);
  const [mediaList, setMediaList] = useState<any[]>([]);
  const size = useSize(document.querySelector('body'));
  const [isLoading, setIsLoading] = useState(true);
  const [bgName, setBgName] = useState<BgNameType>('special');
  const bgRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setSpaceBetween(getRootFontSize() * 0.73);
    setScrollbarVar();
  }, [size]);

  useGSAP(() => {
    const tl = gsap.timeline();

    // 设置背景图
    tl.set(bgRef.current, {
      className: 'bg-img bg-img-special',
    });
    // 第2屏开始 bring...
    tl.from(`.${styles.sectionOurVision}`, {
      yPercent: 100,
      duration: 1,
    });
    tl.to(`.${styles.sectionFirst}`, {
      opacity: 0,
      duration: 0,
    });
    tl.from(
      `.${styles.sectionOurVision} .${styles.pageTitle}`,
      {
        opacity: 0,
        duration: 0.5,
      },
      '-=1',
    );
    tl.from(
      `.${styles.sectionOurVision} p`,
      {
        opacity: 0,
        duration: 0.5,
        top: '-100px',
      },
      '-=0.5',
    );
    tl.set(bgRef.current, {
      className: 'bg-img bg-img-common',
    });
    tl.to(
      `.${styles.sectionOurVision} .${styles.bg}`,
      {
        opacity: 0,
      },
      '<',
    );
    tl.fromTo(
      '#torch2',
      {
        opacity: 0,
        top: '-2rem',
        left: '50%',
        transform: 'translateX(-50%)',
      },
      {
        opacity: 1,
        top: '0',
        left: '50%',
        transform: 'translateX(-50%)',
      },
      '<',
    );
    tl.to(
      `.${styles.sectionOurVision} h3`,
      {
        opacity: 0,
        left: '-100px',
      },
      '+=1',
    );
    tl.to(
      `.${styles.sectionOurVision} p`,
      {
        opacity: 0,
        top: '-100px',
      },
      '<',
    );

    // 第3屏开始 stay hungry
    // tl.from(`.${styles.sectionCoreDevelopment}`, {
    //   zIndex: 50,
    // });
    // tl.fromTo(
    //   `.${styles.sectionCoreDevelopment} h3`,
    //   {
    //     opacity: 0,
    //     left: '-100px',
    //   },
    //   {
    //     opacity: 1,
    //     left: '0',
    //   },
    //   '<',
    // );
    // tl.fromTo(
    //   `.${styles.sectionCoreDevelopment} p`,
    //   {
    //     opacity: 0,
    //     top: '100px',
    //   },
    //   {
    //     opacity: 1,
    //     top: '0',
    //   },
    // );
    // tl.to(
    //   // 第一次移动火把
    //   '#torch2',
    //   {
    //     position: 'fixed',
    //     left: '5.2rem',
    //     top: '1rem',
    //     zIndex: 52,
    //     ease: 'none',
    //   },
    //   '<',
    // );
    // tl.to(
    //   `.${styles.sectionCoreDevelopment}`,
    //   {
    //     opacity: 0,
    //   },
    //   '+=1',
    // );

    // // 第4屏开始 Experience Equality
    // tl.from(`.${styles.sectionExperienceEquality}`, {
    //   zIndex: 50,
    // });
    // tl.fromTo(
    //   `.${styles.sectionExperienceEquality} h3`,
    //   {
    //     opacity: 0,
    //     left: '-100px',
    //   },
    //   {
    //     opacity: 1,
    //     left: '0',
    //   },
    //   '<',
    // );
    // tl.fromTo(
    //   `.${styles.sectionExperienceEquality} p`,
    //   {
    //     opacity: 0,
    //     right: '100px',
    //   },
    //   {
    //     opacity: 1,
    //     right: '0',
    //   },
    //   '<',
    // );
    // tl.to(
    //   // 移动火把
    //   '#torch2',
    //   {
    //     position: 'fixed',
    //     left: '11rem',
    //     top: '1rem',
    //     zIndex: 50,
    //     scale: 1.8,
    //   },
    //   '<',
    // );
    // tl.to(
    //   `.${styles.sectionExperienceEquality}`,
    //   {
    //     opacity: 0,
    //   },
    //   '+=1',
    // );

    // // 第5屏开始 think different
    // tl.fromTo(
    //   bgRef.current,
    //   {
    //     className: 'bg-img bg-img-common',
    //   },
    //   {
    //     className: 'bg-img bg-img-special',
    //   },
    // );
    // tl.from(`.${styles.sectionThinkDifferent}`, {
    //   zIndex: 50,
    // });
    // tl.fromTo(
    //   `.${styles.sectionThinkDifferent} h3`,
    //   {
    //     opacity: 0,
    //     left: '-100px',
    //   },
    //   {
    //     opacity: 1,
    //     left: '0',
    //   },
    //   '<',
    // );
    // tl.fromTo(
    //   `.${styles.sectionThinkDifferent} p`,
    //   {
    //     opacity: 0,
    //     scale: 0.6,
    //   },
    //   {
    //     opacity: 1,
    //     scale: 1,
    //   },
    //   '<',
    // );
    // tl.to(
    //   // 第 3 次移动火把
    //   '#torch2',
    //   {
    //     position: 'fixed',
    //     left: '10rem',
    //     top: '1rem',
    //     zIndex: 52,
    //     scale: 1.6,
    //   },
    //   '<',
    // );
    // tl.to(
    //   `.${styles.sectionThinkDifferent}`,
    //   {
    //     opacity: 0,
    //   },
    //   '+=1',
    // );

    // // 第6屏开始 less is more
    // tl.from(`.${styles.sectionLessIsMore}`, {
    //   zIndex: 50,
    // });
    // tl.fromTo(
    //   `.${styles.sectionLessIsMore} h3`,
    //   {
    //     opacity: 0,
    //     left: '-100px',
    //   },
    //   {
    //     opacity: 1,
    //     left: '0',
    //   },
    //   '<',
    // );
    // tl.fromTo(
    //   `.${styles.sectionLessIsMore} p`,
    //   {
    //     opacity: 0,
    //     left: '-100px',
    //   },
    //   {
    //     opacity: 1,
    //     left: '0',
    //   },
    //   '<',
    // );
    // tl.to(
    //   // 第 4 次移动火把
    //   '#torch2',
    //   {
    //     position: 'fixed',
    //     left: '5.1rem',
    //     top: '1rem',
    //     zIndex: 52,
    //     scale: 1.2,
    //   },
    //   '<',
    // );

    // 第7屏开始 games

    tl.set(`.${styles.sectionGames}`, {
      zIndex: 52,
    });
    tl.from(
      `.${styles.sectionGames}`,
      {
        yPercent: 100,
      },
      // '+=1',
    );

    // 上一屏隐藏
    tl.set(`.${styles.sectionLessIsMore}`, {
      opacity: 0,
    });
    tl.set(`#torch2`, {
      zIndex: 51,
      top: 0,
    });
    tl.set(`.${styles.sectionGames}`, {
      zIndex: 51,
    });

    tl.from(
      `.${styles.sectionGames} .${styles.sectionGamesLeft}`,
      {
        opacity: 0,
        left: '-200px',
      },
      '<',
    );
    tl.from(
      `.${styles.sectionGames} .sectionGamesLeftTop`,
      {
        duration: 1,
        y: -30, // 垂直方向位移
        scaleX: 1.2,
        yoyo: true, // 往返动画
        ease: 'bounce.out', // 弹性缓动函数
      },
      '<',
    );
    tl.from(
      `.${styles.sectionGames} .sectionGamesLeftBottom`,
      {
        duration: 1,
        y: 30, // 垂直方向位移
        scaleX: 1.2,
        yoyo: true, // 往返动画
        ease: 'bounce.out', // 弹性缓动函数
      },
      '<',
    );
    tl.from(
      `.${styles.sectionGames} .sectionGamesRightTop`,
      {
        opacity: 0,
        transform: 'translateY(-200px)',
      },
      '<',
    );
    tl.from(
      `.${styles.sectionGames} .sectionGamesRightBottom`,
      {
        opacity: 0,
        transform: 'translateY(200px)',
      },
      '<',
    );

    // 第8屏开始 blog
    tl.set(`.${styles.sectionBlog}`, {
      zIndex: 51,
    });
    tl.from(
      `.${styles.sectionBlog}`,
      {
        yPercent: 100,
      },
      '+=1',
    );
    tl.from(`.${styles.sectionBlog} .${styles.pageTitle}`, {
      opacity: 0,
      left: '-100px',
    });
    // 上一屏隐藏
    tl.set(
      `.${styles.sectionGames}`,
      {
        opacity: 0,
        zIndex: 51,
      },
      '<',
    );
    tl.from(
      `.${styles.sectionBlog} .${styles.sectionBlogContent}`,
      {
        opacity: 0,
        top: '-100px',
      },
      '<',
    );
    tl.from(
      `.${styles.sectionBlog} .${styles.contentFooter}`,
      {
        opacity: 0,
        // top: '-100px',
      },
      '<',
    );
    // 把背景去掉，统一使用最开始的背景图。
    tl.to(
      `.${styles.sectionBlog} .${styles.bg}`,
      {
        opacity: 0,
      },
      '<',
    );
    tl.to(
      `.${styles.sectionBlog}`,
      {
        opacity: 0,
      },
      '+=1',
    );

    // 第9屏开始 media
    tl.from(`.${styles.sectionMedia}`, {
      opacity: 0,
      zIndex: 50,
    });
    tl.from(
      `.${styles.sectionMedia} .${styles.pageTitle}`,
      {
        opacity: 0,
        left: '-100px',
      },
      '<',
    );
    tl.from(`.${styles.sectionMedia} .${styles.sectionMediaContent}`, {
      opacity: 0,
      top: '-100px',
    });
    tl.to(
      '#torch2',
      {
        left: '11rem',
      },
      '-=0.5',
    );
    tl.to(
      `.${styles.sectionMedia}`,
      {
        opacity: 0,
      },
      '+=1',
    );

    // 第10屏开始 social
    tl.from(`.${styles.sectionSocial}`, {
      opacity: 0,
      zIndex: 50,
    });
    tl.from(
      `.${styles.sectionSocial} .${styles.pageTitle}`,
      {
        opacity: 0,
        left: '-100px',
      },
      '<',
    );
    tl.from(
      `.${styles.sectionSocial} p`,
      {
        scale: 0.8,
        translateX: '100px',
        opacity: 0,
      },
      '<',
    );
    tl.to(
      '#torch2',
      {
        position: 'fixed',
        left: '14rem',
      },
      '<',
    );
    tl.from(`.${styles.sectionSocial} .social-icon`, {
      opacity: 0,
      scale: 0,
      stagger: 0.2,
    });

    tl.to(
      `.${styles.sectionSocial}`,
      {
        opacity: 0,
      },
      '+=1',
    );

    // 第11屏开始 contact
    tl.from(`.${styles.sectionContact}`, {
      opacity: 0,
      zIndex: 50,
    });
    tl.from(`.${styles.sectionContact} .${styles.pageTitle}`, {
      opacity: 0,
      left: '-100px',
    });
    tl.from(
      `.${styles.sectionContact} .${styles.contentItem}`,
      {
        opacity: 0,
        top: '-100px',
        stagger: 0.3,
      },
      '<',
    );
    tl.to(
      `.${styles.sectionContact}`,
      {
        opacity: 1,
      },
      '+=1',
    );

    ScrollTrigger.create({
      animation: tl,
      trigger: `.${styles.page2}`,
      start: 'top top',
      end: '+=10000',
      // end: 'bottom bottom',
      scrub: 1.5,
      pin: true,
      anticipatePin: 1,
      id: 'mainTL',
      // markers: true,
    });
  });

  const getData = () => {
    reqBlogListByPage({
      current: 1,
      size: 2,
    }).then((res) => {
      setBlogList(res.records);
    });

    reqMediaListByPage({
      current: 1,
      size: 2,
    }).then((res) => {
      console.log(res);
      setMediaList(res.records);
    });
  };

  const handleGoInfo = (type: 'blogs' | 'media', item) => {
    history.push(`${type}/info/${item.id}`);
  };

  return (
    <div className={styles.home} id="home">
      <BgImg bgName="special" ref={bgRef} />
      <div className={styles.homeContent}>
        <div className={styles.page2}>
          {/* <TopBlank /> */}
          {/* 首屏 */}
          <section className={classnames('section', styles.page, styles.sectionFirst)}>
            <TorchRing />
          </section>

          <Torch id="torch2" />

          {/* our vision */}
          <section className={classnames('section', styles.page, styles.sectionOurVision)}>
            <h3 className={styles.pageTitle}>Our Vision</h3>
            <p>Bring Exceptional Gaming Experience To Broader And More Diverse Players Worldwide.</p>
            <div className={styles.bg} />
          </section>

          {/* core development */}
          {/* <section className={classnames('section', styles.page, styles.sectionCoreDevelopment)}>
            <h3 className={styles.pageTitle}>
              Core Development
              <br />
              Philosophies
            </h3>
            <p>Stay Hungry</p>
          </section> */}

          {/* experience equality */}
          {/* <section className={classnames('section', styles.page, styles.sectionExperienceEquality)}>
            <h3 className={styles.pageTitle}>
              Core Development
              <br />
              Philosophies
            </h3>
            <p>Experience Equality</p>
          </section> */}

          {/* think different */}
          {/* <section className={classnames('section', styles.page, styles.sectionThinkDifferent)}>
            <h3 className={styles.pageTitle}>
              Core Development
              <br />
              Philosophies
            </h3>
            <p>Think Different</p>
          </section> */}

          {/* less is more */}
          {/* <section className={classnames('section', styles.page, styles.sectionLessIsMore)}>
            <h3 className={styles.pageTitle}>
              Core Development
              <br />
              Philosophies
            </h3>
            <p>Less Is More</p>
          </section> */}

          {/* games */}
          <section className={classnames('section', styles.page, styles.sectionGames)}>
            <div className={styles.bg} />
            <div className={styles.sectionGamesBg}>
              <Image src={gamesBg} preview={false} />

              <div className={styles.sectionGamesLeft}>
                <Image className="sectionGamesLeftTop" src={logoBlockBlast} preview={false} width="3.48rem" />
                <p>
                  Free and addictive <br />
                  block puzzle mini-game
                </p>
                <Image className="sectionGamesLeftBottom" src={childs} preview={false} width="2.1rem" />
              </div>

              <div className={styles.sectionGamesRight}>
                <a
                  href="https://apps.apple.com/cn/app/id1617391485"
                  target="_blank"
                  style={{
                    width: '2.33rem',
                  }}
                  className="sectionGamesRightTop"
                >
                  <Image src={iconApple} preview={false} width="2.33rem" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.block.juggle"
                  target="_blank"
                  style={{
                    width: '2.33rem',
                  }}
                  className="sectionGamesRightBottom"
                >
                  <Image style={{ marginTop: '.42rem' }} src={iconGoogle} preview={false} />
                </a>
              </div>
            </div>

            <MySwiper data={phoneList}>
              {(el, index) => {
                return <Image src={el} preview={false} />;
              }}
            </MySwiper>
          </section>

          {/* blog */}
          <section className={classnames('section', styles.page, styles.sectionBlog)}>
            <div className={styles.bg} />
            <h3 className={styles.pageTitle}>Blogs</h3>
            <div className={styles.sectionBlogContent}>
              {blogList.map((blog, index) => (
                <div className={classnames(styles.sectionBlogContentItem, styles.contentItem)} key={index}>
                  {blog.newsTime && <div className={styles.itemTime}>{formatDate(blog.newsTime)}</div>}
                  <p className={styles.itemTitle} onClick={() => handleGoInfo('blogs', blog)}>
                    {blog.title}
                  </p>
                </div>
              ))}
            </div>

            <div className={styles.contentFooter}>
              <div className={styles.blogMore} onClick={() => history.push('/blogs/more')}>
                MORE
              </div>
              {/* <div
                className={classnames(styles.blogDownload)}
                onClick={() =>
                  window.open('https://drive.google.com/drive/folders/1pc_j1FATRSCl5TuVPjLCUG0G4yRTVVVS', '_blank')
                }
              >
                <div className={styles.blogDownloadTop}>PRESS KIT</div>
                <div>DOWNLOAD</div>
                <div className={styles.blogDownloadIcon} />
              </div> */}
            </div>
          </section>

          {/* media */}
          <section className={classnames('section', styles.page, styles.sectionMedia)}>
            <h3 className={styles.pageTitle}>Media</h3>
            <div className={styles.sectionMediaContent}>
              {mediaList.map((media, index) => (
                <div className={styles.contentItem} key={index}>
                  <div className="flex flex-y-start">
                    {media.newsTime && <div className={styles.itemTime}>{formatDate(media.newsTime)}</div>}
                    <div className={styles.itemSource}>{media.subTitle}</div>
                  </div>
                  <p className={styles.itemTitle} onClick={() => handleGoInfo('media', media)}>
                    {media.title}
                  </p>
                </div>
              ))}
            </div>

            <div className={classnames('flex', styles.contentFooter)}>
              <div className={styles.mediaMore} onClick={() => history.push('/media/more')}>
                MORE
              </div>
              <div
                className={classnames(styles.blogDownload)}
                onClick={() =>
                  window.open('https://drive.google.com/drive/folders/1pc_j1FATRSCl5TuVPjLCUG0G4yRTVVVS', '_blank')
                }
              >
                <div className={styles.blogDownloadTop}>PRESS KIT</div>
                <div>DOWNLOAD</div>
                <div className={styles.blogDownloadIcon} />
              </div>
            </div>
          </section>

          {/* social */}
          <section className={classnames('section', styles.page, styles.sectionSocial)}>
            <div className={styles.pageTitle}>Social</div>
            <p style={{ marginBottom: '.25rem' }}>
              Follow & Join <br /> Our Community
            </p>

            <div className="flex">
              <div style={{ marginBottom: '.25rem' }}>
                <div className={styles.socialType}>Company</div>
                <div className="flex">
                  <a
                    href="https://www.linkedin.com/company/hungrystudio2021/"
                    target="_blank"
                    style={{ marginRight: '.54rem' }}
                    className="social-icon"
                  >
                    <Image src={iconLinkedin} preview={false} />
                  </a>
                  <a href="https://www.youtube.com/@hungrystudio_games" target="_blank" className="social-icon">
                    <Image src={iconYoutube} preview={false} />
                  </a>
                </div>
              </div>

              <div style={{ marginLeft: '2.8rem' }}>
                <div className={styles.socialType}>Featured posts</div>
                <div className="flex cursor-pointer social-icon" onClick={() => history.push('/social/selected')}>
                  <Image src={iconHotspot} preview={false} />
                </div>
              </div>
            </div>
            <div>
              <div className={styles.socialType}>Games</div>
              <div className={classnames('flex', styles.socialGames)}>
                <a href="https://www.tiktok.com/@blockblastofficial" target="_blank" className="social-icon">
                  <Image src={tiktok} preview={false} />
                </a>
                <a href="https://www.instagram.com/blockblastglobal/" target="_blank" className="social-icon">
                  <Image src={instagram} preview={false} />
                </a>
                <a href="https://x.com/BlockBlastSquad" target="_blank" className="social-icon">
                  <Image src={twitter} preview={false} />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61564167488999"
                  target="_blank"
                  className="social-icon"
                >
                  <Image src={facebook} preview={false} />
                </a>
                <a href="https://www.youtube.com/@BlockBlastOfficial" target="_blank" className="social-icon">
                  <Image src={gamesYoutube} preview={false} />
                </a>
                <a href="discord.gg/ZeJZrhMurC" target="_blank" className="social-icon">
                  <Image src={discord} preview={false} />
                </a>
              </div>
            </div>
          </section>

          {/* contact */}
          <section className={classnames('section', styles.page, styles.sectionContact)}>
            <h3 className={styles.pageTitle}>Contact</h3>
            {contactData.map((item, index) => {
              return (
                <div className={styles.contentItem} key={index}>
                  <p className={styles.itemTitle}>{item.title}</p>
                  <div className={styles.itemEmail}>{item.address}</div>
                </div>
              );
            })}

            <div className={styles.sectionContactFooter}>
              <span className="torch-left" onClick={() => history.push('/contact/info/22')}>
                Terms of Use
              </span>
              <span className="torch-right" onClick={() => history.push('/contact/info/23')}>
                Privacy Policy
              </span>
            </div>
          </section>
        </div>
      </div>

      <ScrollArrow />
    </div>
  );
};

export default Home;
